export default __webpack_public_path__ + "static/media/P207 zu P204.9668ac76.mp3";